import React from "react";
import $ from "jquery";
import leftPng from "../../../../content/images/left.png";
import dateTimePng from "../../../../content/images/date-time.png";
import * as omnimap from "../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "./functions/callBackFunctions";
import * as CommonFunctions from "./functions/commonFunctions";
import * as GC from "../../../common/common";
import { connect } from "react-redux";
import { SaveOrUpdate } from "../../../../redux/actions/catalogManagementUnitsAction";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";

class Edit extends React.Component {
  constructor(props) {
    super(props);
    this.rowId =
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.rowId;
    this.state = {
      rowData: this.props.history.location.state.rowData,
      //
      omschrijving: this.props.history.location.state.rowData.omschrijving,
      datumaanvang: this.handleDate(
        this.props.history.location.state.rowData.datumaanvang
      ),
      datumoplevering: this.handleDate(
        this.props.history.location.state.rowData.datumoplevering
      ),
      opdrachtgever: this.props.history.location.state.rowData.opdrachtgever,
      eenheid: this.props.history.location.state.rowData.eenheid,
      eenheidsprijs: this.props.history.location.state.rowData.eenheidsprijs,
      kostentotaal: this.props.history.location.state.rowData.totaal,
      kostenperjaar: this.props.history.location.state.rowData.kostenPerJaar,
      opmerking: this.props.history.location.state.rowData.opmerking,
      akkoord: this.props.history.location.state.rowData.akkoord,
      actief: this.props.history.location.state.rowData.isActive,
      omschrijvingRequiredAlert: "",
      omschrijvingAlertText: "",
      code: this.props.history.location.state.rowData.algemeenCodeBase,
      codeRequiredAlert: false,
      codeAlertText: "",
      // dropdown
      selectBudget: false,
      selectWerkplan: false,
      selectOrganisatie: false,
      selectDirectievoeder: false,
      selectToezichthouder: false,
      selectEenheid: false,
      //

      //budget
      handleSelectBudget: false,
      budgets: [],
      selectedBudget: this.props.history.location.state.rowData.budget,
      selectedBudgetId: null,
      selectedBudgetCode: null,
      //werkplan
      handleSelectWerkplan: false,
      werkplans: [],
      selectedWerkplan: this.props.history.location.state.rowData.werkplan,
      selectedWerkplanId: null,
      selectedWerkplanCode: null,
      //Organisatie
      handleSelectOrganization: false,
      organizations: [],
      selectedOrganization:
        this.props.history.location.state.rowData.organisatie,
      selectedOrganizationId: null,
      //Directievoerder
      handleSelectDirectievoerder: false,
      directievoerders: [],
      selectedDirectievoerder:
        this.props.history.location.state.rowData.directievoerder,
      selectedDirectievoerderId: null,
      //Toezichthouder
      handleSelectToezichthouder: false,
      toezichthouders: [],
      selectedToezichthouder:
        this.props.history.location.state.rowData.toezichthouder,
      selectedToezichthouderId: null,
      relationRoles: [
        "Verplichting voor werkplan",
        "Verplichting in budget",
        "Verplichting voor uitvoerdersorganisatie",
        "Toezichthouder voor verplichting",
        "Directievoerder voor verplichting",
      ],
      // startDate: this.handleDate(
      //   this.props.history.location.state.rowData.startDate
      // ),
      // endDate: this.handleDate(
      //   this.props.history.location.state.rowData.endDate
      // ),
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
  }

  handleDate(date) {
    var translateDate = String(date.replaceAll("-", "/"));
    translateDate =
      translateDate.split("/")[1] +
      "/" +
      translateDate.split("/")[0] +
      "/" +
      translateDate.split("/")[2];

    translateDate = new Date(translateDate);

    return GC.FormatDateReverse(translateDate, "date");
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });

    if (value != "" && name == "startDate") {
      this.setState({ beginRequiredAlert: false });
    }
    if (value != "" && name == "endDate") {
      this.setState({ endRequiredAlert: false });
    }
    if (value != "" && name == "naam") {
      this.setState({ naamRequiredAlert: false });
    }
  }
  handleSelectChange(name, value) {
    this.setState({
      [name]: value,
    });
  }

  async handleSubmit(event) {
    event.preventDefault();
    $("#cover-spin").show(0);

    var horizon_begin = this.state.begin + "T00:00:00.000Z";
    var horizon_end = this.state.end + "T00:00:00.000Z";
    this.state.omschrijving == ""
      ? await this.setState({
          omschrijvingRequiredAlert: true,
          omschrijvingAlertText: "required",
        })
      : await this.setState({
          omschrijvingRequiredAlert: false,
          omschrijvingAlertText: "",
        });
    this.state.code == ""
      ? await this.setState({
          codeRequiredAlert: true,
          codeAlertText: "required",
        })
      : await this.setState({ codeRequiredAlert: false, codeAlertText: "" });
    var model = {
      relationships: { definition: { code: "VERPLICHTING" } },
      content: {
        algemeen: {
          omschrijving: this.state.omschrijving,
          code: this.state.code,

          datumaanvang: this.state.datumaanvang,
          datumoplevering: this.state.datumoplevering,
          opdrachtgever: this.state.opdrachtgever,
          eenheid: this.state.eenheid,
          eenheidsprijs: this.state.eenheidsprijs,
          kostentotaal: this.state.kostentotaal,
          kostenperjaar: this.state.kostenperjaar,
          opmerking: this.state.opmerking,
          akkoord: this.state.akkoord,
          actief: this.state.actief,
        },
      },
      identification: this.rowId,
    };

    if (this.state.datumaanvang) {
      model.content.algemeen.datumaanvang = this.state.datumaanvang;
    }
    if (this.state.datumoplevering) {
      model.content.algemeen.datumoplevering = this.state.datumoplevering;
    }

    let isUnique = true;
    let uniqueModel = {
      content: [
        {
          and_or: "AND",
          datatype: "STRING",
          key: "algemeen-code",
          values: [this.state.code],
        },
      ],
      definitions: [process.env.REACT_APP_USER_OBLIGATIONS],
      sorting: [],
    };

    //** code isunique control.
    await omnimap
      .FillTableAction(uniqueModel, 1, window.$catalog_management_units_token)
      .then((result) => {
        if (
          result.data &&
          result.data.length > 0 &&
          result.data[0].identification !== this.rowId
        ) {
          isUnique = false;
          this.setState({
            codeRequiredAlert: true,
            codeAlertText: "is not unique",
          });
        }
      });

    if (
      this.state.omschrijvingRequiredAlert !== true &&
      this.state.codeRequiredAlert !== true &&
      isUnique === true
    ) {
      var data = await omnimap.SaveOrEditAction(model, "PATCH", this.rowId);
      if (data.result.status === "OK") {
        CallBackFunctions.SubmitCallBack(window.$mm_management_units_token);
        this.props.history.push("/management-maintenance/obligations");

        let realtions = await omnimap.GetRelationAction(this.rowId, 1, 30);

        /**
         * * 1. silinmek istenen kayıtın beheerobject ilişkisi varsa sinemez olması gerekmektedir
         */

        if (realtions.data !== undefined) {
          await realtions.data.forEach(async (relation) => {
            let result = this.state.relationRoles.filter(
              (x) => x === relation.role
            );
            if (result.length > 0) {
              await omnimap
                .DeleteRelationAction(relation.identification)
                .catch((error) => {
                  console.log(error);
                });
            }
          });
        }

        GC.sleep(2000).then(async () => {
          // Directievoerder
          await GC.StartActivity(
            {
              directievoerder: {
                identification: this.state.selectedDirectievoerderId,
                display: [
                  {
                    path: "$.alias",
                    value: this.state.selectedDirectievoerder,
                  },
                ],
              },
              naamdirectievoerder: this.state.selectedDirectievoerder,
            },
            [this.rowId],
            "cb6279b4-99db-4003-a93a-193d560a41fd",
            null,
            window.$mm_management_units_token
          );
          // toezichthouder
          await GC.StartActivity(
            {
              toezichthouder: {
                identification: this.state.selectedToezichthouderId,
                display: [
                  { path: "$.alias", value: this.state.selectedToezichthouder },
                ],
              },
              naamtoezichthouder: this.state.selectedToezichthouder,
            },
            [this.rowId],
            "b905237c-e32e-4c3c-8f5d-6afec5366736",
            null,
            window.$mm_management_units_token
          );

          // toezichthouder
          await GC.StartActivity(
            {
              organisatie: this.state.selectedOrganizationId,
              naamorganisatie: this.state.selectedOrganization,
            },
            [this.rowId],
            "4fc3522e-d36d-4d67-8d71-34b16917d590",
            null,
            window.$mm_management_units_token
          );

          // budget
          await GC.StartActivity(
            {
              budget: this.state.selectedBudgetId,
              naambudget: this.state.selectedBudget,
            },
            [this.rowId],
            "c75bb9f9-63cc-4335-91e2-24cf7ba28067",
            null,
            window.$mm_management_units_token
          );
          // werkplan
          await GC.StartActivity(
            {
              werkplan: this.state.selectedWerkplanId,
              naamwerkplan: this.state.selectedWerkplan,
            },
            [this.rowId],
            "744fae0c-2dff-4999-99b5-6cf99f9d3390",
            null,
            window.$mm_management_units_token
          );
        });
      }
    } else {
      $("#cover-spin").hide(0);
    }
  }

  // budget
  async getBudgets() {
    const budgets = await omnimap.FillTableAction(
      {
        content: [
          {
            key: "algemeen-actief",
            and_or: "AND",
            values: [true],
            datatype: "BOOLEAN",
          },
        ],
        definitions: [process.env.REACT_APP_CATALOG_BUDGET],
      },
      1
    );
    await this.setState({
      budgets: budgets.data,
      selectedBudgetId: budgets.data
        .filter((x) => x.name === this.state.selectedBudget)
        .map(function (obj) {
          return obj.identification;
        })[0],
    });
  }

  // werkplan
  async getWerkplans() {
    const werkplans = await omnimap.FillTableAction(
      {
        content: [
          {
            key: "algemeen-actief",
            and_or: "AND",
            values: [true],
            datatype: "BOOLEAN",
          },
        ],
        definitions: [process.env.REACT_APP_CATALOG_WORK_PLANS],
      },
      1,
      window.$mm_management_units_token
    );
    await this.setState({
      werkplans: werkplans.data,
      selectedWerkplanId: werkplans.data
        .filter((x) => x.name === this.state.selectedWerkplan)
        .map(function (obj) {
          return obj.identification;
        })[0],
    });
  }

  // organization
  async getOrganization() {
    const organizations = await omnimap.FillTableAction(
      {
        content: [
          {
            key: "algemeen-actief",
            and_or: "AND",
            values: [true],
            datatype: "BOOLEAN",
          },
        ],
        definitions: [process.env.REACT_APP_USER_ORGANISATION],
      },
      1,
      window.$mm_management_units_token
    );
    await this.setState({
      organizations: organizations.data,
      selectedOrganizationId: organizations.data
        .filter((x) => x.name === this.state.selectedOrganization)
        .map(function (obj) {
          return obj.identification;
        })[0],
    });
  }

  // Directievoerder
  async getDirectievoerder() {
    const directievoerders = await omnimap.GetUserByRoleAction(
      1,
      30,
      "Directievoerder",
      window.$mm_management_units_token
    );

    await this.setState({
      directievoerders: directievoerders.data,
      selectedOrganizationId: directievoerders.data
        .filter((x) => x.name === this.state.selectedOrganization)
        .map(function (obj) {
          return obj.identification;
        })[0],
    });
  }

  // Toezichthouder
  async getToezichthouder() {
    const toezichthouders = await omnimap.GetUserByRoleAction(
      1,
      30,
      "Toezichthouder",
      window.$mm_management_units_token
    );
    await omnimap.FillTableAction(
      {
        content: [
          {
            key: "algemeen-actief",
            and_or: "AND",
            values: [true],
            datatype: "BOOLEAN",
          },
        ],
        definitions: [process.env.REACT_APP_USER_ORGANISATION],
      },
      1,
      window.$mm_management_units_token
    );
    await this.setState({
      toezichthouders: toezichthouders.data,
      selectedToezichthouderId: toezichthouders.data
        .filter((x) => x.name === this.state.selectedToezichthouder)
        .map(function (obj) {
          return obj.identification;
        })[0],
    });
  }

  // budget

  async handleBudget(budget, e) {
    const element = e.target;

    await this.setState({
      selectedBudget: budget ? budget.name : null,
      selectedBudgetId: budget ? budget.identification : null,
      selectedBudgetCode: budget ? budget.content["algemeen-code"] : null,
    });
  }
  // werkplan

  async handleWerkplan(werkplan, e) {
    await this.setState({
      selectedWerkplan: werkplan ? werkplan.name : null,
      selectedWerkplanId: werkplan ? werkplan.identification : null,
      selectedWerkplanCode: werkplan ? werkplan.content["algemeen-code"] : null,
    });
  }
  // organization

  async handleOrganization(organization, e) {
    await this.setState({
      selectedOrganization: organization ? organization.name : null,
      selectedOrganizationId: organization ? organization.identification : null,
    });
  }
  // Directievoerder

  async handleDirectievoerder(directievoerder, e) {
    await this.setState({
      selectedDirectievoerder: directievoerder ? directievoerder.alias : null,
      selectedDirectievoerderId: directievoerder
        ? directievoerder.identification
        : null,
    });
  }
  // Toezichthouder

  async handleToezichthouder(toezichthouder, e) {
    await this.setState({
      selectedToezichthouder: toezichthouder ? toezichthouder.alias : null,
      selectedToezichthouderId: toezichthouder
        ? toezichthouder.identification
        : null,
    });
  }

  async componentDidMount() {
    const { actions } = this.props;
    await this.getBudgets();
    await this.getWerkplans();
    await this.getOrganization();
    await this.getDirectievoerder();
    await this.getToezichthouder();
    await CommonFunctions.GetColumnProperties("edit");
  }

  render() {
    return (
      <div id="editSide" /*className="d-none"*/>
        <div className="detail-title">Test -- Verplichtingen in edit</div>
        <div className="clearfix">
          <div className="float-left mt-4">
            <a
              id="detail-button"
              className="back-page-link"
              role="button"
              onClick={() => {
                this.props.history.push("/management-maintenance/obligations");
              }}
            >
              <img src={leftPng} width={9} height={12} /> &nbsp;Terug naar
              Verplichtingen
            </a>
          </div>
          <div className="float-right mt-0">
            <a onClick={this.handleSubmit.bind(this)} className="button ok">
              Opslaan
            </a>
          </div>
          <div className="float-right mt-0 w-20">
            <a
              onClick={() => {
                this.props.history.push(
                  "/management-maintenance/obligations/detail/" + this.rowId,
                  {
                    rowData: this.state.rowData,
                  }
                );
              }}
              className="button back"
            >
              Annuleren
            </a>
          </div>
        </div>

        <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail-active">
              <div className="box-title-1-active">Code</div>
              <div className="box-title-2-active">
                <input
                  type="text"
                  name="code"
                  value={this.state.code}
                  autocomplete="off"
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Omschrijving</div>
              <div className="box-title-2">
                <input
                  name="omschrijving"
                  value={this.state.omschrijving}
                  autocomplete="off"
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Budget</div>
              <div
                className={
                  this.state.selectBudget
                    ? "box-title-2 select-content open"
                    : "box-title-2 select-content"
                }
                onClick={() =>
                  this.handleSelectChange(
                    "selectBudget",
                    !this.state.selectBudget
                  )
                }
              >
                <input
                  type="button"
                  className="edit-dropdown"
                  value={this.state.selectedBudget}
                />
                <div class="popup-dropdown">
                  <span
                    className={
                      this.state.selectBudget
                        ? "popuptext-dropdown show"
                        : "popuptext-dropdown"
                    }
                  >
                    {this.state.budgets.map((m) => (
                      <a
                        class="popuptext-dropdown-a"
                        name={m.name}
                        onClick={this.handleBudget.bind(this, m)}
                      >
                        [{m.content["algemeen-code"]}] {"\u00A0"} {m.name}
                      </a>
                    ))}
                  </span>
                </div>

                {/* <select class="form-control" id="e-eenheid" hidden></select> */}
              </div>
            </div>
          </div>
        </div>
        <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Werkplan</div>
              <div
                className={
                  this.state.selectWerkplan
                    ? "box-title-2 select-content open"
                    : "box-title-2 select-content"
                }
                onClick={() =>
                  this.handleSelectChange(
                    "selectWerkplan",
                    !this.state.selectWerkplan
                  )
                }
              >
                <input
                  type="button"
                  className="edit-dropdown"
                  value={this.state.selectedWerkplan}
                />
                <div class="popup-dropdown">
                  <span
                    className={
                      this.state.selectWerkplan
                        ? "popuptext-dropdown show"
                        : "popuptext-dropdown"
                    }
                  >
                    {this.state.werkplans.map((m) => (
                      <a
                        class="popuptext-dropdown-a"
                        name={m.name}
                        onClick={this.handleWerkplan.bind(this, m)}
                      >
                        [{m.content["algemeen-code"]}] {"\u00A0"} {m.name}
                      </a>
                    ))}
                  </span>
                </div>

                {/* <select class="form-control" id="e-eenheid" hidden></select> */}
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Boekingsnummer</div>
              <div className="box-title-2">
                <input
                  type="text"
                  name="boekingsnummer"
                  value={this.state.boekingsnummer}
                  onChange={this.handleInputChange}
                  autocomplete="off"
                />
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Datum aanvang</div>
              <div className="box-title-2">
                <input
                  type="date"
                  name="datumaanvang"
                  value={this.state.datumaanvang}
                  onChange={this.handleInputChange}
                  autocomplete="off"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Datum oplevering</div>
              <div className="box-title-2">
                <input
                  type="date"
                  name="datumoplevering"
                  value={this.state.datumoplevering}
                  onChange={this.handleInputChange}
                  autocomplete="off"
                />
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Organisatie</div>
              <div className="box-title-2">
                <div
                  className={
                    this.state.selectOrganisatie
                      ? "box-title-2 select-content open"
                      : "box-title-2 select-content"
                  }
                  onClick={() =>
                    this.handleSelectChange(
                      "selectOrganisatie",
                      !this.state.selectOrganisatie
                    )
                  }
                >
                  <input
                    type="button"
                    className="edit-dropdown"
                    value={this.state.selectedOrganization}
                  />
                  <div class="popup-dropdown">
                    <span
                      className={
                        this.state.selectOrganisatie
                          ? "popuptext-dropdown show"
                          : "popuptext-dropdown"
                      }
                    >
                      {this.state.organizations.map((m) => (
                        <a
                          class="popuptext-dropdown-a"
                          name={m.name}
                          onClick={this.handleOrganization.bind(this, m)}
                        >
                          {m.name}
                        </a>
                      ))}
                    </span>
                  </div>

                  {/* <select class="form-control" id="e-eenheid" hidden></select> */}
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Opdrachtgever</div>
              <div className="box-title-2">
                <input
                  type="text"
                  name="opdrachtgever"
                  value={this.state.opdrachtgever}
                  onChange={this.handleInputChange}
                  autocomplete="off"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Directievoeder</div>
              <div className="box-title-2">
                <div
                  className={
                    this.state.selectDirectievoeder
                      ? "box-title-2 select-content open"
                      : "box-title-2 select-content"
                  }
                  onClick={() =>
                    this.handleSelectChange(
                      "selectDirectievoeder",
                      !this.state.selectDirectievoeder
                    )
                  }
                >
                  <input
                    type="button"
                    className="edit-dropdown"
                    value={this.state.selectedDirectievoerder}
                  />
                  <div class="popup-dropdown">
                    <span
                      className={
                        this.state.selectDirectievoeder
                          ? "popuptext-dropdown show"
                          : "popuptext-dropdown"
                      }
                    >
                      {this.state.directievoerders.map((m) => (
                        <a
                          class="popuptext-dropdown-a"
                          name={m.alias}
                          onClick={this.handleDirectievoerder.bind(this, m)}
                        >
                          {m.alias}
                        </a>
                      ))}
                    </span>
                  </div>

                  {/* <select class="form-control" id="e-eenheid" hidden></select> */}
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Toezichthouder</div>
              <div className="box-title-2">
                <div
                  className={
                    this.state.selectToezichthouder
                      ? "box-title-2 select-content open"
                      : "box-title-2 select-content"
                  }
                  onClick={() =>
                    this.handleSelectChange(
                      "selectToezichthouder",
                      !this.state.selectToezichthouder
                    )
                  }
                >
                  <input
                    type="button"
                    className="edit-dropdown"
                    value={this.state.selectedToezichthouder}
                  />
                  <div class="popup-dropdown">
                    <span
                      className={
                        this.state.selectToezichthouder
                          ? "popuptext-dropdown show"
                          : "popuptext-dropdown"
                      }
                    >
                      {this.state.toezichthouders.map((m) => (
                        <a
                          class="popuptext-dropdown-a"
                          name={m.alias}
                          onClick={this.handleToezichthouder.bind(this, m)}
                        >
                          {m.alias}
                        </a>
                      ))}
                    </span>
                  </div>

                  {/* <select class="form-control" id="e-eenheid" hidden></select> */}
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Eenheid</div>
              <div
                className={
                  this.state.selectEenheid
                    ? "box-title-2 select-content open"
                    : "box-title-2 select-content"
                }
                onClick={() =>
                  this.handleSelectChange(
                    "selectEenheid",
                    !this.state.selectEenheid
                  )
                }
              >
                <input
                  type="button"
                  className="edit-dropdown"
                  value={this.state.eenheid}
                />
                <div class="popup-dropdown">
                  <span
                    id="obligations-eenheid"
                    className={
                      this.state.selectEenheid
                        ? "popuptext-dropdown show"
                        : "popuptext-dropdown"
                    }
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Eenheidsprijs (€)</div>
              <div className="box-title-2">
                <input
                  type="number"
                  min={0}
                  name="eenheidsprijs"
                  value={this.state.eenheidsprijs}
                  onChange={this.handleInputChange}
                  autocomplete="off"
                />
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Totaal (€)</div>
              <div className="box-title-2">
                <input
                  type="number"
                  min={0}
                  name="kostentotaal"
                  value={this.state.kostentotaal}
                  onChange={this.handleInputChange}
                  autocomplete="off"
                />
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Kosten per jaar (€)</div>
              <div className="box-title-2">
                <input
                  type="number"
                  min={0}
                  name="kostenperjaar"
                  value={this.state.kostenperjaar}
                  onChange={this.handleInputChange}
                  autocomplete="off"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Opmerking</div>
              <div className="box-title-2">
                <input
                  name="opmerking"
                  value={this.state.opmerking}
                  autocomplete="off"
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
          </div>

          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box--title-1">Akkord</div>
              <label className="switch">
                <input
                  type="checkbox"
                  name="akkoord"
                  onChange={this.handleInputChange}
                  checked={this.state.akkoord ? true : false}
                />
                <span className="slider-checkbox round" />
              </label>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Status</div>
              <label className="switch">
                <input
                  type="checkbox"
                  name="actief"
                  onChange={this.handleInputChange}
                  checked={this.state.actief ? true : false}
                />
                <span className="slider-checkbox round" />
              </label>
            </div>
          </div>
        </div>

        {/* <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail-active">
              <div className="box-title-1-active">Naam Beheereenheid</div>
              <div className="box-title-2-active">
                <input
                  id="e-algemeenNaam"
                  autocomplete="off"
                  value={this.state.naam}
                  name="naam"
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Code Beheereenheid</div>
              <div className="box-title-2">
                <input
                  id="e-algemeenCode"
                  autocomplete="off"
                  value={this.state.code}
                  name="code"
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Actief</div>
              <label className="switch">
                <input
                  id="e-beheereenheid_active"
                  type="checkbox"
                  name="isActive"
                  onChange={this.handleInputChange}
                  checked={this.state.isActive ? true : false}
                />
                <span className="slider-checkbox round" />
              </label>
            </div>
          </div>
        </div>
        <div className="row clearfix">
          <div className="col-sm-6">
            <div
              className={
                this.state.beginRequiredAlert
                  ? "inp-labl modale-submit-alert-block"
                  : "inp-labl"
              }
            >
              Start horizon
            </div>
            <div
              className="inp-labl modale-submit-alert-block"
              hidden={this.state.beginRequiredAlert ? false : true}
            >
              ,{"\u00A0"}date entered is invalid.
            </div>
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <img src={dateTimePng} width={30} height={28} />
                </span>
              </div>
              <input
                type="date"
                className="form-control inp-h inpp"
                id="e-startDate"
                value={this.state.startDate}
                name="startDate"
                onChange={this.handleInputChange}
              />
            </div>
          </div>
          <div className="col-sm-6">
            <div
              className={
                this.state.endRequiredAlert
                  ? "inp-labl modale-submit-alert-block"
                  : "inp-labl"
              }
            >
              Eind horizon
            </div>
            <div
              className="inp-labl modale-submit-alert-block"
              hidden={this.state.endRequiredAlert ? false : true}
            >
              ,{"\u00A0"}
              {this.state.endRequiredText}
            </div>
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <img src={dateTimePng} width={30} height={28} />
                </span>
              </div>
              <input
                type="date"
                className="form-control inp-h inpp"
                id="e-endDate"
                value={this.state.endDate}
                name="endDate"
                onChange={this.handleInputChange}
                min={this.state.startDate}
              />
            </div>
          </div>
        </div> */}

        <input hidden id="e-identification" />
      </div>
    );
  }
}

// export default Edit;
Edit.propTypes = {
  SaveOrUpdate: PropTypes.func.isRequired,
};
function mapStateToProps(state, ownProps) {
  return {
    catalogManagementUnits: state.rowData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      SaveOrUpdate: bindActionCreators(SaveOrUpdate, dispatch),
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Edit);
